export default __webpack_public_path__ + "static/media/members_receive_3.0b9c8002.jpg";